/* Produse complementare: sageti stanga/dreapta (ca la slider). 2026-10-12 */
(function () {
  var css = '.cp-wrap{position:relative;display:block}' +
    '.cp-arrow{position:absolute;top:calc(50% - 6px);transform:translateY(-50%);z-index:3;width:38px;height:38px;border-radius:50%;border:0;background:#fff;color:#1f1f1f;box-shadow:0 2px 10px rgba(0,0,0,.18);display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;transition:opacity .2s}' +
    '.cp-arrow:hover{background:#f4f4f4}' +
    '.cp-arrow svg{width:16px;height:16px}' +
    '.cp-prev{left:6px}.cp-next{right:6px}' +
    '.cp-arrow[disabled]{opacity:0;pointer-events:none}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function icon(d) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>';
  }

  function update(inner, prev, next) {
    var max = inner.scrollWidth - inner.clientWidth - 2;
    prev.disabled = inner.scrollLeft <= 2;
    next.disabled = inner.scrollLeft >= max;
  }

  function setup(inner) {
    if (inner.dataset.cpArrows) return;
    var wrap = inner.closest('scroll-shadow') || inner.parentElement;
    if (!wrap) return;
    inner.dataset.cpArrows = '1';
    wrap.classList.add('cp-wrap');

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'cp-arrow cp-prev';
    prev.setAttribute('aria-label', 'Înapoi');
    prev.innerHTML = icon('M15 18l-6-6 6-6');

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'cp-arrow cp-next';
    next.setAttribute('aria-label', 'Înainte');
    next.innerHTML = icon('M9 18l6-6-6-6');

    wrap.appendChild(prev);
    wrap.appendChild(next);

    function step() {
      var card = inner.firstElementChild;
      return card ? card.getBoundingClientRect().width + 10 : inner.clientWidth * 0.8;
    }
    prev.addEventListener('click', function () { inner.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { inner.scrollBy({ left: step(), behavior: 'smooth' }); });
    inner.addEventListener('scroll', function () { update(inner, prev, next); }, { passive: true });
    window.addEventListener('resize', function () { update(inner, prev, next); });
    update(inner, prev, next);
    setTimeout(function () { update(inner, prev, next); }, 600);
  }

  function scan() {
    document.querySelectorAll('.complementary-products--inner').forEach(setup);
  }

  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
})();
